<template>
	<div class="userinfor">
		<div class="flex-title">用户信息</div>
		<div class="message" v-loading="userInfoLoading">
			<div class="access">
				<div class="option">
					<i class="iconfont icon-xinxi"></i>&nbsp;&nbsp;访问信息
				</div>
				<div>
					<div class="lablelist">
						<span>来源渠道</span>
						<span>{{ channelName }}</span>
					</div>
					<div class="lablelist">
						<span>隐私条款</span>
						<span
							v-show="
								userInfo.userInfo.treatyOfConsent != undefined
							"
							>{{
								userInfo.userInfo.treatyOfConsent == true
									? '已同意'
									: '未同意'
							}}</span
						>
					</div>
				</div>
			</div>
			<div class="access">
				<div class="option">
					<i class="iconfont icon-yonghu"></i>&nbsp;&nbsp;用户信息
				</div>
				<el-form
					ref="form"
					label-width="75px"
					size="mini"
					style="margin-top: 15px;"
				>
					<el-form-item label="姓名">
						<el-input
							v-model="userInfo.userInfo.realName"
							v-if="isEdit"
						></el-input>
						<span class="userText" v-if="!isEdit">{{
							userInfo.userInfo.realName
						}}</span>
					</el-form-item>
					<el-form-item label="授权手机号">
						<span class="userText">{{
							mobileMaskStatus?userInfo.userInfo.mobile:getMaskMobile(userInfo.userInfo.mobile)
						}}  <i class="el-icon-view isSee" @click="switchMaskStatus" v-if="userInfo.userInfo.mobile!=undefined && userInfo.userInfo.mobile!='' && isEdit==false"></i> </span>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input
							v-model="userInfo.userInfo.mobile1"
							v-if="isEdit"
						></el-input>
						<span v-if="!isEdit" class="userText">{{
							mobileMaskStatus?userInfo.userInfo.mobile1:getMaskMobile(userInfo.userInfo.mobile1) 
						}}  </span>
					</el-form-item>
					<el-form-item label="邮箱">
						<el-input
							v-model="userInfo.userInfo.email"
							v-if="isEdit"
						></el-input>
						<span v-if="!isEdit" class="userText">{{
							userInfo.userInfo.email
						}}</span>
					</el-form-item>
					<el-form-item label="地址">
						<!-- @change="handleChange" -->
						<el-cascader
							style="width: 183px"
							v-model="selectedVal"
							:options="addressList"
						></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址">
						<el-input
							type="textarea"
							:rows="2"
							style="width: 183px"
							placeholder="请输入详细地址"
							v-model="userInfo.userInfo.detailed_Address"
							v-if="isEdit"
						></el-input>
						<span v-if="!isEdit" class="userText">{{
							userInfo.userInfo.detailed_Address
						}}</span>
					</el-form-item>
					<el-form-item label="访客备注" size="large">
						<el-input
							type="textarea"
							:rows="2"
							style="width: 183px"
							v-model="userInfo.userInfo.remarks"
							v-if="isEdit"
						></el-input>
						<span v-if="!isEdit" class="userText">{{
							userInfo.userInfo.remarks
						}}</span>
					</el-form-item>
					<el-form-item size="large">
						<el-button type="primary" @click="onSubmit">{{
							isEdit == false ? '编辑' : '保存'
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="access">
				<div class="lablelist">
					<span>
						<i class="el-icon-collection-tag" />&nbsp;&nbsp;标签
					</span>
					<i
						class="iconfont icon-jia"
						@click="labelChangevisible(true)"
					></i>
					<div class="lables1" style="margin-top: 15px">
						<span
							v-for="(item, index) in userInfo.tags.filter(
								(d) => d.selected > 0
							)"
							class="tags"
							:key="index"
							:style="{ background: item.label_Color }"
						>
							{{ item.label_Name }}
							<span class="opert" @click="handleCloseTag(item)">
								<i class="el-icon-close"></i>
							</span>
						</span>
						<div class="clear"></div>
					</div>
				</div>
			</div>
			<div class="access">
				<div class="option">
					<i class="iconfont icon-gongdan"></i>
					&nbsp;&nbsp;工单({{ userInfo.workOrderLists.length }})
				</div>
				<div style="padding: 10px 0">
					<span style="color: #666">新建关联工单</span>
					<span @click="createWorkOrder">
						<i class="iconfont icon-jia"></i>
					</span>
				</div>
				<div
					class="lablelist"
					id="workOrder"
					style="max-height: 200px; overflow: auto"
				>
					<div
						:key="index"
						v-for="(item, index) in userInfo.workOrderLists"
						class="workOrderList"
					>
						<div>
							<span>{{ item.product_name }}</span>
						</div>
						<div>
							<span style>{{
								getTimeVal(item.create_Time)
							}}</span>
							<span style="float: right">
								<a class @click="SeeWorkOrder(item)">查看</a>
							</span>
						</div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
			<a id="go" style="display: none" target="_blank"></a>
			<div class="access">
				<div class="option">
					<i class="iconfont icon-gongdan"></i>&nbsp;&nbsp;服务小记
				</div>
				<!-- label-position="top" -->
				<el-form
					label-width="70px"
					:model="subTotal"
					ref="subtotalRuleForm"
					size="mini"
					class="form_1"
					:rules="subtotalRules"
				>
					<el-form-item label="解决状态" prop="state">
						<el-radio-group size="mini" v-model="subTotal.state">
							<el-radio-button :label="1">已解决</el-radio-button>
							<el-radio-button :label="0">未解决</el-radio-button>
							<el-radio-button :label="2">无效会话</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="联系规格" prop="contactSpecificationsId">
					 
						<el-select v-model="subTotal.contactSpecificationsId" style="width:100%"  placeholder="请选择">
							<el-option
							v-for="item in contactSpecificationsList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="危机程度" prop="crisisId">
						<el-select v-model="subTotal.crisisId" style="width:100%"    placeholder="请选择">
							<el-option
							v-for="item in crisisList"
							:key="item.id"
							:label="item.crisisName"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="产品名称">
						<productTree
						 v-model="subTotal.productId"
						 :currentNodeKey='subTotal.currentNodeKeyProduct' 
						 @onSelectedId='onSelectedProductId'
						/>
					</el-form-item>
					<el-form-item label="联络原因">
						<consultationTypeTree 
						 v-if="subTotal"
						 :currentNodeKey='subTotal.currentNodeKey' 
						 @onSelectedId='onSelectedId'
						/>
						<consultationTypeTree 
						 v-else
						 :currentNodeKey='subTotal.currentNodeKey' 
						 @onSelectedId='onSelectedId'
						/>
						<!-- <el-select
							v-model="subTotal.consultationTypeId"
							placeholder="请选择"
						>
							<el-option
								v-for="item in consultationTypes"
								:key="item.id"
								:label="item.typeName"
								:value="item.id"
							></el-option>
						</el-select> -->
				
					</el-form-item>
					<el-form-item label="内容说明">
						<el-input
							type="textarea"
							style="margin-top: 10px"
							resize="none"
							maxlength="450"
							show-word-limit
							placeholder="请输入备注信息"
							v-model="subTotal.remarks"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button
							type="primary"
							@click="saveCustomerCenter('subtotalRuleForm')"
							>保存</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<div class="access">
				<div class="option">
					<i class="iconfont icon-jilu"></i>&nbsp;&nbsp;服务记录
				</div>
				<div class="serviceList">
					<div style="width: 100%;text-align: center;margin-top: 15px;color:#606266;" v-if="serviceRecord.length==0">暂无数据</div>
					<div
						class="lablelist"
						:key="index"
						v-for="(item, index) in serviceRecord"
					>
						<span id="tagState" v-show="item.state == 0">未</span>
						<span>{{ item.startTimeString }}</span>
						<span class="f-right" @click="serviceRecordShow(item)"
							>查看记录</span
						>
					</div>

					
				</div>
			</div>
		</div>
		<selectedTag
			@LabelChangevisible="labelChangevisible"
			@updTag="updTag"
			:dialogLabelvisible="dialogLabelvisible"
			:data="userInfo.tags"
		></selectedTag>

		<el-dialog
			title="服务记录"
			:visible.sync="serviceRecordVisible"
			width="50%"
			:before-close="handleCloseSerRecord"
		>
			<el-card shadow="never">
				<el-form :inline="true" label-width="70px" >
					<el-form-item label="解决状态">
						<el-select
							v-model="singleSubTotal.problemState"
						>
							<el-option
								:key="key"
								v-for="(item, key) in problemStateList"
								:label="item.label"
								:value="item.val"
							></el-option>
						</el-select>
					</el-form-item>
					 
					<el-form-item label="联络原因">
						 <div style="width:200px;margin-top:5px">
							<consultationTypeTree
							 :currentNodeKey='singleSubTotal.currentNodeKey' 
							 v-model="singleSubTotal.consultationTypeId" 
							 @onSelectedId='onSelectedIdSingleSub' />
						 </div>
					</el-form-item>
					<el-form-item label="联系规格" prop="contactSpecificationsId">
						
					 	<el-select v-model="singleSubTotal.contactSpecificationsId"  placeholder="请选择">
							<el-option :key="0" label="请选择" :value="0"></el-option>
							<el-option
							v-for="item in contactSpecificationsList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="危机程度" prop="crisisId">
						<el-select v-model="singleSubTotal.crisisId"  placeholder="请选择">
							<el-option :key="0" label="请选择" :value="0"></el-option>
							<el-option
							v-for="item in crisisList"
							:key="item.id"
							:label="item.crisisName"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="内容说明">
						<el-input
							type="textarea"
							autosize
							placeholder="请输入内容"
							 
							v-model="singleSubTotal.remarks"
						></el-input>
					</el-form-item>
					<el-form-item >
						<el-button type="primary" @click="saveCustomerCenter1">保存</el-button>
					</el-form-item>
				</el-form>
			</el-card>
 
			
			 <el-card style="margin-top:15px"  shadow="never">
				<div slot="header" class="clearfix">
					<span>咨询记录</span>
				</div>
				<div class="talk" id="testDiv">
					<div class="container">
						<p>{{ getTimeVal(singleSubTotal.startTime) }} 用户接入</p>
						<div
							:key="index"
							:class="
								item.dialogues[0].sender == 2
									? 'talk_right'
									: 'talk_left'
							"
							v-for="(item, index) in singleSubTotal.messages"
						>
							<div
								class="content"
								v-if="item.dialogues[0].sender === 2"
							>
								<div class="text">
									<span
										:key="index"
										v-for="(items, index) in item.dialogues"
										v-if="items.messageType !== 10"
									>
										<img
											v-if="items.messageType === 2"
											:src="items.content"
											v-image-preview
										/>
										<video
											v-else-if="items.messageType === 3"
											:src="items.content"
											controls="controls"
										></video>
										<a
											v-else-if="items.messageType === 6"
											:href="items.content"
											>{{ items.content }}</a
										>
										<span v-else>{{ items.content }}</span>
									</span>
								</div>
								<span class="itemTime">{{
									getTimeVal(item.sendTime)
								}}</span>
							</div>
							<div
								class="heading"
								v-if="item.dialogues[0].sender == 2"
							>
								<img :src="item.sendHeadimg" />
							</div>
							<div
								class="heading"
								v-if="item.dialogues[0].sender == 1"
							>
								<img :src="item.sendHeadimg" />
							</div>
							<div
								class="content"
								v-if="item.dialogues[0].sender == 1"
							>
								<div class="text">
									<span
										:key="index"
										v-for="(items, index) in item.dialogues"
										v-if="items.messageType !== 10"
									>
										<img
											v-if="items.messageType === 2"
											:src="items.content"
											v-image-preview
										/>
										<video
											v-else-if="items.messageType === 3"
											:src="items.content"
											controls="controls"
										></video>
										<a
											v-else-if="items.messageType === 6"
											:href="items.content"
											>{{ items.content }}</a
										>
										<span v-else>{{ items.content }}</span>
									</span>
								</div>
								<span class="itemTime">{{
									getTimeVal(item.sendTime)
								}}</span>
							</div>
						</div>
					</div>
				</div>
			 </el-card>
		</el-dialog>
		<!-- 工单详情弹窗 -->
		<el-dialog
			title="工单详情"
			:visible.sync="centerDialogVisible"
			width="30%"
			center
			:modal="false"
		>
			<div class="list">
				<div
					class="option"
					:key="index"
					v-for="(item, index) in datalist"
				>
					<span class="left">{{ item.ename }} ：</span>
					<span class="right">{{ workOrderObj[item.content] }}</span>
				</div>
				<div class="clear"></div>
			</div>
			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
			</span>-->
		</el-dialog>
	</div>
</template>

<script>
import selectedTag from './selectedTag'
import { FormatTimes } from '@/utils/FormatTime'
import { DateTime } from '@/utils/common'
import { Base64 } from 'js-base64'
import consultationTypeTree  from './consultationTypeTree.vue'
import productTree  from './productTree.vue'
export default {
	name: 'userInfo',
	data() {
		return {
			dialogLabelvisible: false,
			selectedVal: [],
			isSolve: 0,
			userInfo: {
				userInfo: {
					mobile: '',
					realName: '',
					email: '',
					mobile1: '',
					remarks: '',
					detailed_Address: '',
					treatyOfConsent: undefined,
				},
				tags: [],
				workOrderLists: [],
			},
			subTotal: {
				id: 0,
				accessChatId: 0,
				state: 0,
				consultationTypeId: undefined,
				remarks: '',
				currentNodeKey:[],
				currentNodeKeyProduct:[],
				contactSpecificationsId:0,
				crisisId:0,
				productId:0
			},
			serviceRecordVisible: false,
			serviceRecords: {},
			singleSubTotal: {
				problemState: '0',
				consultationTypeId: undefined,
				remarks: '123213',
				contactSpecificationsId:0,
				crisisId:0,
				currentNodeKey:[],
				currentNodeKeyProduct:[]
			},
			problemStateList: [
				{ val: 0, label: '未解决' },
				{ val: 1, label: '已解决' },
			],
			subtotalRules: {
				state: [
					{
						required: true,
						message: '请选择解决状态',
						trigger: 'change',
					},
				],
				contactSpecificationsId:[{
					required:true,
					message:'请选择联系规格',
					trigger: 'change'
				}],
				crisisId:[{
					required: true,
					message: '请选择危机程度',
					trigger: 'change',
				}]
			},
			whetherToSave: false, //当前服务小计是否保存
			workOrderObj: {
				session_id: '',
				order_id: 0,
				real_name: '',
				mobile: '',
				product_name: '',
				contact_reason: '',
				contact_specifications: '',
				retailers: '',
				content: '',
				openid: '',
				create_time: '',
				state: '',
				service_object: '',
				close_time: '',
			},
			datalist: [
				{
					ename: '会话ID',
					content: 'session_id',
				},
				{
					ename: '工单ID',
					content: 'order_id',
				},
				{
					ename: '姓名',
					content: 'real_name',
				},
				{
					ename: '手机号',
					content: 'mobile',
				},
				{
					ename: '产品名称',
					content: 'product_name',
				},
				{
					ename: '联络原因',
					content: 'contact_reason',
				},
				{
					ename: '联系规格',
					content: 'contact_specifications',
				},
				{
					ename: '零售商',
					content: 'retailers',
				},
				{
					ename: '小程序openid',
					content: 'openid',
				},
				{
					ename: '工单状态',
					content: 'state',
				},
				{
					ename: '服务对象',
					content: 'service_object',
				},
				{
					ename: '关闭时间',
					content: 'close_time',
				},
			],
			centerDialogVisible: false,
			addressList: [],
			isEdit: false,
			currentUserInfos: {},
			selectedOpenid: '',
			selectedaccessChatId: 0,
			userInfoLoading: false,
			mobileMaskStatus:false,
			contactSpecificationsList:[],
			crisisList:[]
		 
		}
	},
	props: {
		// addressList: {
		// 	type: Array,
		// 	default: () => []
		// },
		currentUserInfo: {
			type: Object,
			default: () => {},
		},
		// consultationTypes: {
		// 	type: Array,
		// 	default: () => [],
		// },
		serviceRecord: {
			type: Array,
			default: () => [],
		},
		channelName: {
			type: String,
			default: '',
		},
		accessChatId: {
			type: Number,
			default: 0,
		},
		openid: {
			type: String,
			default: '',
		},
		processButton: {
			type: Boolean,
			default: false,
		},
		auditChannel:{
			type:String,
			default:'获取用户信息'
		},
		rowKey:{
			type:Number,
			default:0
		}
	},
	created: function () {
		let $this = this
		this.connection.on('RefreshWorkOrder', (message) => {
			$this.getUserInfo($this.selectedOpenid, $this.selectedaccessChatId)
		})
		this.getContactSpecifications();
		this.getCrisisEnum();
	},
	computed: {
		openidAndAccessChatId() {
			 
			const { openid, accessChatId,rowKey } = this
			 
			return {
				openid,
				accessChatId,
				rowKey
			}
		},
	},
	watch: {
		currentUserInfos:{

			handler:function(val,oldVal){
				 
			if (Object.keys(val).length == 0) {
				this.selectedVal = []
				this.userInfo = {
					userInfo: {
						mobile: '',
						mobile1: '',
						realName: '',
						email: '',
						remarks: '',
						detailed_Address: '',
					},
					tags: [],
					workOrderLists: [],
				}
				this.subTotal = {
					id: 0,
					accessChatId: 0,
					state: 0,
					consultationTypeId: undefined,
					remarks: '',
					currentNodeKey:[],
					currentNodeKeyProduct:[],
					productId:0,
				}
			} else {
				this.isEdit = false
				this.userInfo = val
				console.debug(val)
				this.selectedVal = [
					val.userInfo.province,
					val.userInfo.city,
					val.userInfo.district,
				]
				 
				if (val.subTotal == null) {
					this.subTotal = {
						id: 0,
						accessChatId: 0,
						state: 0,
						consultationTypeId: undefined,
						remarks: '',
						currentNodeKey:[],
						currentNodeKeyProduct:[]
					}
				}
				if (val.subTotal) {
					this.subTotal = val.subTotal
					if (this.subTotal.consultationTypeId == 0) {
						this.subTotal.consultationTypeId = undefined
					}
					this.subTotal.state = val.subTotal.state
					this.subTotal.currentNodeKey=val.subTotal.currentNodeKey;
					this.subTotal.currentNodeKeyProduct=val.subTotal.currentNodeKeyProduct;
				}
			}
			this.whetherToSave = false
			},
			deep: true,
			immediate: true
		
		},
		openidAndAccessChatId: {
			handler: function (newval, oldval) {
			 

				this.getUserInfo(newval.openid, newval.accessChatId)
				this.selectedOpenid = newval.openid
				this.selectedaccessChatId = newval.accessChatId
				this.rowKey=newval.rowKey;
			},
			deep: true,
			immediate: true,
		}
	},
	mounted: function () {
		this.getAddress()
	},
	methods: {
		labelChangevisible(val) {
			let vm = this
			if (Object.keys(vm.currentUserInfos).length == 0) {
				vm.$confirm('请先选中咨询人', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					showCancelButton: false,
				})
				return
			}
			this.dialogLabelvisible = val
		},
		handleChange(val) {
			let vm = this
			let arr = Object.keys(this.currentUserInfos)
			if (arr.length == 0) {
				this.$message('请您先选中咨询人，在保存资料。')
				return
			}
			val = vm.selectedVal
			if (val.length > 0) {
				this.userInfo.userInfo.province = val[0]
				this.userInfo.userInfo.city = val[1]
				this.userInfo.userInfo.district = val[2]
				this.$emit('updUserInfo', this.userInfo.userInfo)
			}
		},
		saveCustomerCenter(formName) {
			let vm = this
			if (Object.keys(vm.currentUserInfos).length == 0) {
				 
				this.$confirm('请先选中咨询人，在进行保存！', '错误', {
					confirmButtonText: '确定',
					type: 'error',
					showCancelButton: false,
				})
				return
			}
			this.$refs[formName].validate((valid) => {
				 
				if (valid) {
					vm.$emit('saveCustomerCenter', { ...this.subTotal }, () => {
						vm.customerWhetherToSave
					})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		customerWhetherToSave() {
			this.whetherToSave = true
		},
		saveCustomerCenter1() {
			let obj = { ...this.singleSubTotal }
			let obj2 = {}
			obj2.accessChatId = obj.accessChatId
			obj2.state = obj.problemState
			obj2.consultationTypeId = obj.consultationTypeId
			obj2.remarks = obj.remarks
			obj2.contactSpecificationsId=obj.contactSpecificationsId;
			obj2.crisisId=obj.crisisId;
			this.$emit('saveCustomerCenter', obj2)
		},
		UpdUserInfo() {
			let arr = Object.keys(this.currentUserInfos)
			if (arr.length == 0) {
				this.$message('请您先选中咨询人，在保存资料。')
				return
			}
			this.$emit('updUserInfo', this.userInfo.userInfo)
		},
		updTag(val) {
			let vm = this
			this.axios
				.post(
					`ConsultantInfoLabel_Relation/updRelation?miniOpenId=${vm.currentUserInfos.userInfo.miniOpenid}`,
					vm.userInfo.tags
				)
				.then(function ({ data }) {})
		},
		handleCloseTag(val) {
			let vm = this
			let index = vm.userInfo.tags.findIndex(
				(d) => d.label_Id == val.label_Id
			)
			if (index > -1) {
				vm.userInfo.tags[index].selected = 0
				this.axios
					.get(
						`ConsultantInfoLabel_Relation/DeleteRela?labelId=${val.label_Id}&id=${this.currentUserInfos.userInfo.id}`
					)
					.then(function ({ data }) {})
			}
		},
		serviceRecordShow(val) {
			let vm = this
			vm.serviceRecordVisible = true
			this.axios
				.get('AccessChat/GetServiceRecord', {
					params: { accessChatId: val.accessChatId },
				})
				.then(function ({ data }) {
					 
					if (data.data.problemState == -1) {
						data.data.problemState = undefined
					}
					if (data.data.consultationTypeId == -1) {
						data.data.consultationTypeId = undefined
					}
					if(data.data.consultationTypeId>0){
						data.data.currentNodeKey=[data.data.consultationTypeId];
					}
					if(data.data.productId){
						data.data.currentNodeKeyProduct=[data.data.productId];
					}
					vm.singleSubTotal = data.data
				})
		},
		handleCloseSerRecord() {
			let vm = this
			vm.serviceRecordVisible = false
			vm.singleSubTotal={
				problemState: '0',
				consultationTypeId: undefined,
				remarks: '',
				contactSpecificationsId:0,
				crisisId:0,
				currentNodeKey:[],
				currentNodeKeyProduct:[],
				productId:0
			}
		},
		getTimeVal(time) {
			let dat = new DateTime()
			if (time == undefined) {
				return FormatTimes(this.create_time, 'hh:mm:ss')
			} else {
				let cont = FormatTimes(time, 'yyyy-MM-dd')
				let cont1 = dat.getDate()
				if (cont === cont1) {
					return FormatTimes(time, 'hh:mm:ss')
				} else {
					return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
				}
			}
		},
		createWorkOrder() {
			// location.href = `http://139.196.85.132:8099/Call/InsertCase?openid=omytO5VHPq2f9VkS1-q0bFUUq60s&sessionId=10473&username=wtest1`

			// location.href = `http://139.196.85.132:8099/Home/AuthApi?syscode=wechatcs&sessionid=10473&openid=omytO5VHPq2f9VkS1-q0bFUUq60s&username=wtest1`
			// return
			let vm = this
			let obj2 = localStorage.getItem(vm.LoginInfo)
			if (obj2 == undefined || obj2 == null) {
				vm.$message({
					type: 'error',
					message: '获取工单账号失败,请重试',
				})
				return
			}
			let userInfo = JSON.parse(obj2)
			if (
				vm.currentUserInfos.userInfo.miniOpenid != undefined &&
				vm.accessChatId > 0 &&
				(vm.currentUserInfos.userInfo.mobile != undefined ||
					vm.currentUserInfos.userInfo.mobile1 != undefined)
			) {
				let phone = ''
				if (
					vm.currentUserInfos.userInfo.mobile1 != '' &&
					vm.currentUserInfos.userInfo.mobile1 != undefined &&
					vm.currentUserInfos.userInfo.mobile1 != null
				) {
					phone = vm.currentUserInfos.userInfo.mobile1
				} else {
					phone = vm.currentUserInfos.userInfo.mobile
				}
				//let downloadUrl = `http://10.79.3.25/Home/AuthApi?syscode=wechatcs&sessionid=${vm.accessChatId}&openid=${vm.currentUserInfos.userInfo.miniOpenid}&username=${userInfo.account}&&phone=${phone}`

				let downloadUrl = `https://ncs.nestlechinese.com/Home/AuthApi?syscode=wechatcs&sessionid=${vm.accessChatId}&openid=${vm.currentUserInfos.userInfo.miniOpenid}&username=${userInfo.account}&&phone=${phone}`
				let a = document.getElementById('go')

				a.href = downloadUrl
				document.getElementById('go').click()
				// location.href = `http://139.196.85.132:8099/Call/InsertCase?openid=${vm.currentUserInfo.userInfo.miniOpenid}&sessionId=${vm.accessChatId}&`
			} else {
				this.$confirm('参数值错误,请重试！', '提示', {
					confirmButtonText: '确定',
					showCancelButton: false,
					type: 'warning',
				})
			}
		},
		SeeWorkOrder(val) {
			let vm = this
			let obj2 = localStorage.getItem(vm.LoginInfo)
			if (obj2 == undefined || obj2 == null) {
				vm.$message({
					type: 'error',
					message: '获取工单账号失败,请重试',
				})
				return
			}
			let userInfo = JSON.parse(obj2)
			//let downloadUrl = `http://10.79.3.25/Home/AuthApi?syscode=wechatcs&sessionid=&username=${userInfo.account}&caseId=${val.order_id}`
			let downloadUrl = `https://ncs.nestlechinese.com/Home/AuthApi?syscode=wechatcs&sessionid=&username=${userInfo.account}&caseId=${val.order_id}`
			let a = document.getElementById('go')
			a.href = downloadUrl
			document.getElementById('go').click()
		},
		saveAddressMonitorting(obj) {
			let vm = this
			let selected = []
			let province = vm.addressList.find((d) => d.label == obj.Province)
			if (province != undefined) {
				selected.push(province.value)
				let city = province.children.find((d) => d.label == obj.City)
				if (city != undefined) {
					selected.push(city.value)
					let Country = city.children.find(
						(d) => d.label == obj.Country
					)
					if (Country != undefined) {
						selected.push(Country.value)
					} else {
						selected.push(city.children[0].value)
					}
				} else {
					let citys = province.children[0]
					selected.push(citys.value)
					selected.push(citys.children[0].value)
				}
			}
			if (
				obj.address != '县' &&
				obj.address != '区' &&
				obj.address != ''
			) {
				vm.userInfo.userInfo.detailed_Address = obj.address
			}
			if (selected.length > 0) {
				vm.selectedVal = selected
				vm.handleChange()
				vm.UpdUserInfo()
			}
			//保存识别的地址
		},
		getWorkOrder(id) {
			let vm = this
			this.axios
				.get('workOrder/getWorkOrder', { params: { order_id: id } })
				.then(function ({ data }) {
					if (data.result) {
						vm.workOrderObj = data.data
						vm.centerDialogVisible = true
					}
				})
		},
		getAddress() {
			let vm = this
			this.axios.get('Address/GetAdd').then(function ({ data }) {
				if (data.result) {
					vm.addressList = data.data
				}
			})
		},
		onSubmit() {
			let vm = this
			if (!vm.isEdit) {
				vm.isEdit = true
				return
			}

			// vm.handleChange()
			vm.UpdUserInfo()
			vm.isEdit = false
		},
		getUserInfo(openid, accessChatId) {
			 
			let vm = this
			 
			if (
				openid == '' ||
				accessChatId == 0 ||
				accessChatId == undefined ||
				accessChatId == null ||
				openid == undefined ||
				openid == null
			) {
				vm.currentUserInfos = {}
				return
			}
			 
			vm.$emit('onLoading', true)
			vm.userInfoLoading = true
		 
			let str1 = Base64.encode(vm.auditChannel)
			
			this.axios
				.get('ConsultantInfo/getUserInfo', {
					params: { openid: openid, accessChatId: accessChatId },
					headers:{ AuditChannel :str1 }
				})
				.then(function ({ data }) {
					 
					if (data.result) {
						  
						if(data.data.subTotal){
							data.data.subTotal.currentNodeKey=[data.data.subTotal.consultationTypeId]
							data.data.subTotal.currentNodeKeyProduct = [data.data.subTotal.productId]
						}else{
							data.data.subTotal = {
								id: 0,
								accessChatId: 0,
								state: 0,
								consultationTypeId: undefined,
								remarks: '',
								currentNodeKey:[],
								currentNodeKeyProduct:[]
							}
						}
						 vm.subTotal=data.data.subTotal;
						vm.currentUserInfos = data.data
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
					vm.$emit('onLoading', false)
					vm.userInfoLoading = false
				})
		},
		getAccount() {
			let json = window.localStorage.getItem('USER_INFO')
			let obj = json != null ? JSON.parse(json) : null
			return obj.account
		},
		getMaskMobile(mobile){
			var real = /(\d{3})\d{4}(\d{4})/;
			if(mobile!=undefined && mobile!=""){
				return mobile.replace(real, "$1****$2");
			}else{
				return "";
			}
			
		},
		switchMaskStatus(){
			this.mobileMaskStatus=!this.mobileMaskStatus
		},
		onSelectedId(val){
			  
			if(val.length>0){
				this.subTotal.consultationTypeId=val[0];
				this.subTotal.currentNodeKey=[val[0]];
 
			}else{
				this.subTotal.consultationTypeId=0;
				this.subTotal.currentNodeKey=[];
			}
			console.debug(this.subTotal);
		
		},
		onSelectedProductId(val){
			//currentNodeKeyProduct
			if(val.length>0){
				this.subTotal.productId=val[0];
				this.subTotal.currentNodeKeyProduct=[val[0]];
 
			}else{
				this.subTotal.productId=0;
				this.subTotal.currentNodeKeyProduct=[];
			}
		},
		onSelectedIdSingleSub(val){
			 
			if(val.length>0){
				console.debug(this.singleSubTotal)
				this.singleSubTotal.consultationTypeId=val[0];
				this.singleSubTotal.currentNodeKey=val;
			}else{
				this.singleSubTotal.consultationTypeId=0;
				this.singleSubTotal.currentNodeKey=[];
			}
		},
		getContactSpecifications(){
			let vm =this;
			
			this.axios.get('/ContactSpecifications').then(function({data}){
				vm.contactSpecificationsList=data.data
			})
		},
		getCrisisEnum(){
	
			let vm =this;
			
			this.axios.get('/CrisisEnum').then(function({data}){
				vm.crisisList=data.data
			})
		}
	},
	components: {
		selectedTag,
		consultationTypeTree,
		productTree
	},
}
</script>
<style scoped>
.form_1 {
	 width: 300px;
	 
}
/* .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  } */

 
.message {
	padding: 0px 0 30px 15px;
	box-sizing: border-box;
}
.access {
	margin-top: 20px;
	/* margin-bottom: 15px; */
}

.option {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 15px;
}

.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
}
.lablelist span input {
	border: 1px solid transparent;
	padding-left: 10px;
	line-height: 32px;
	height: 32px;
	border-radius: 5px;
}
.lablelist span input:hover {
	border: 1px solid #ccc;
}
.lablelist span.special {
	vertical-align: top;
}
.iconfont {
	cursor: pointer;
}
.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}
.remark {
	resize: none;
	margin-top: 10px;
	font-size: 12px;
}
.save {
	float: right;
	margin: 10px 20px;
}
.f-right {
	float: right;
	cursor: pointer;
}
.userinfor {
	width: 20%;
	height: 100%;
	overflow: auto;
}
.userinfor::-webkit-scrollbar {
	display: none;
}

.flex {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.points {
	height: 36px;
	line-height: 35px;
	padding-left: 30px;
	font-size: 14px;
	color: #fe1c11;
}

.connect {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
}

.Transfer {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	margin: 4px;
}

.ended {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #f74b55;
	margin: 4px 0px 4px 4px;
}

.title {
	height: 42px;
	line-height: 42px;
	background-color: #f2f3f5;
	font-size: 14px;
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-left: 20px;
}

.aside title {
	padding-left: 30px;
	border-bottom: 1px solid #ddd;
}

.reply .title {
	padding: 0 10px;
}

.transition-box {
	padding: 10px 15px;
	border-bottom: 1px solid #eee;
}

.tips {
	float: right;
	border-radius: 15px;
	padding: 0 15px;
	cursor: pointer;
}

.tips.green {
	color: #fff;
	background-color: #047d0c;
}

.tips.red {
	color: #fff;
	background-color: #f74b55;
}

.tips.blue {
	color: #3781ff;
	padding: 0;
}

.user {
	line-height: 25px;
}

.from {
	margin-top: 10px;
}

.create_time {
	float: right;
}

.el-icon-caret-right {
	font-size: 20px;
	margin-right: 5px;
}

.el-icon-caret-bottom {
	font-size: 20px;
	margin-right: 5px;
}

.flex-title {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}

.nickname {
	color: #bbb;
}

.flex-time span {
	color: #fe1c11;
}

.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}

.container {
	overflow-x: hidden;
	overflow-y: auto;
}
.talk {
	padding: 10px 35px;
	height: 400px;

	overflow-y: auto;
	overflow-x: hidden;
}
.search-box {
	line-height: 44px;
}
.search-box .el-input-group {
	width: 320px;
	margin-left: 20px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
::-webkit-scrollbar {
	width: 14px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}
a:hover {
	color: #ff0000;
}
a {
	color: #409eff;
}
.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 300px;
}
.text {
	max-width: 400px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
}
.text span {
	display: inline-block;
	width: 100%;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}
.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.serviceRecord div {
	display: inline-block;
	width: 49%;
	text-align: center;
	color: #bbb;
	font-size: 12px;
}
.serviceList {
	height:150px;
	max-height: 300px;
	overflow-x: auto;
}
.serviceList::-webkit-scrollbar {
	width: 8px;
}
/*滚动条样式*/
::-webkit-scrollbar {
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}

</style>
<style>
.userinfor .el-textarea__inner {
	font-size: 12px;
}
.userinfor .el-radio,
.el-radio--medium.is-bordered .el-radio__label {
	font-size: 12px;
}
.userinfor .el-radio__label {
	font-size: 12px;
}

.userinfor .el-input__inner {
	font-size: 12px;
}
.userinfor .lables1 .tags {
	display: inline-block;
	padding: 0 3px;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	color: #fff;
	margin: 0 10px 0 0px;
	margin-bottom: 5px;
	border-radius: 3px;
	position: relative;
	cursor: pointer;
}
.userinfor .lables1 .opert {
	display: none;
}
.userinfor .lables1 {
	max-width: 80%;
	color: white;
}
.userinfor .lables1 .tags:hover .opert {
	cursor: pointer;
	display: block;
	position: absolute;
	width: 15px;
	height: 15px;
	line-height: 15px;
	margin-left: 3px;
	border-radius: 50%;
	color: white;
	text-align: center;
	background-color: red;
	top: -23px;
	right: -23px;
}
#tagState {
	margin: 0px;
	width: 15px;
	height: 15px;
	background: red;
	line-height: 15px;
	text-align: center;
	font-size: 5px;
	color: white;
}
.list .option {
	line-height: 22px;
	font-size: 14px;
}
.list .option .left {
	width: 45%;
	text-align: right;
	float: left;
}
.list .option .right {
	width: 55%;
	text-align: left;
	float: left;
}
#workOrder a:hover {
	cursor: pointer;
}
.workOrderList:hover {
	background-color: #ccc;
	cursor: pointer;
}
.userText {
	width: 183px;
	display: inline-block;
	word-wrap: break-word;
	word-break: break-all;
	overflow: hidden;
	line-height: 15px;
	margin-top: 6px;
}
.isSee:hover {
	color: #409eff;
	cursor:pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/userInfo.vue